<template>
  <div class="video-bg">

     <div class="box-video" :class="{'position-relative': relative}">
      <video ref="video" id="background-video" class="video-js vjs-default-skin vjs-no-icons" loop :muted="$store.getters.muted && $store.getters.platform === 'browser'"></video>

      <div id="overlay"></div>
    </div>

  </div>
</template>

<script>
import videojs from 'video.js'
require('videojs-contrib-hls')

export default {
  name: 'VideoBg',
  props: ['src', 'bg', 'relative'],
  data () {
    return {
      player: null
    }
  },
  mounted () {
    this.player = videojs(this.$refs.video, {
      controls: false,
      autoplay: true,
      preload: 'auto',
      fluid: true,
      errorDisplay: false
    }, () => {
      this.setSrc()
    })
  },
  methods: {
    setSrc: function () {
      this.player.src(this.getFormatSrc(this.src))
      this.show()
    },
    play () { this.$refs.video.play() },
    pause () { this.$refs.video.pause() },
    show () {
      let bgImg = new Image()
      bgImg.onload = () => { setTimeout(() => { this.$el.style.opacity = 1 }, 2000) }
      bgImg.onerror = () => { setTimeout(() => { this.$el.style.opacity = 1 }, 2000) }
      bgImg.src = this.bg
    },
    getFormatSrc: function (url) {
      const urlNoParams = url.split('?')[0]
      const format = (urlNoParams.endsWith('.mp4') || urlNoParams.endsWith('.m4v')) ? 'video/mp4' : 'application/x-mpegURL'
      return {type: format, src: url}
    }
  },
  beforeDestroy: function () {
    if (this.player) this.player.dispose()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.video-bg
  opacity: 0
  transition: opacity 1s linear

  .box-video
    position: fixed
    top: 0
    bottom: 0
    width: 100%
    height: 100%
    overflow: hidden
    background-color: red

    .video-js
      width: 100%
      height: 100%

      video
        /* Make video to at least 100% wide and tall */
        min-width: 100%
        min-height: 100%

        /* Setting width & height to auto prevents the browser from stretching or squishing the video */
        width: auto
        height: auto

        /* Center the video */
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%,-50%)

  .position-relative
    position: relative

#overlay
  position: absolute
  top: 0
  right: 0
  left: 0
  bottom: 0
  width: 100%
  height: 102%
  // background: linear-gradient(to top, rgba(0, 0, 0, .9), rgba(0, 0, 0, 0))
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), black 80%)
</style>



// WEBPACK FOOTER //
// src/components/video-bg.vue